module.exports = __webpack_public_path__ + "media/images/fonts/Open24DisplaySt-c4efb6934f5c144a19ed468eaf357cd4.ttf";